import { render } from "./noteoss.vue?vue&type=template&id=5f85d15a&scoped=true"
import script from "./noteoss.vue?vue&type=script&lang=js"
export * from "./noteoss.vue?vue&type=script&lang=js"

import "./noteoss.vue?vue&type=style&index=0&id=5f85d15a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f85d15a"]])

export default __exports__